import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { PageEvent } from "@angular/material/paginator";
import { IPredisposition, IPredispositionsFilters } from "@gloria-public/home/domain/interfaces/home.interface";
import { BackendTableDataSource } from "@shared/utils/backend-table.datasource";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-predispositions-table",
  templateUrl: "./predispositions-table.component.html",
  styleUrls: ["./predispositions-table.component.scss"],
})
export class PredispositionsTableComponent implements OnInit, OnDestroy {
  @Input() title = ""; // Title displayed above the table
  @Input() dataSource!: BackendTableDataSource<IPredisposition>; // The datasource to use. Created by the parent and injected here, so the parent controls which API calls are made.
  @Input() filters: IPredispositionsFilters = { lang: "en", page: 1, pageSize: 10, tags: [] }; // Initial filters (page, pageSize). The type should already be set by the parent.

  public totalCount = 0;
  public readonly pageSizeOptions = [5, 10, 20, 50];

  /** Emits when the component is destroyed, used to complete all active subscriptions */
  private onDestroy$ = new Subject<void>();

  /**
   * Subscribe to the datasource count.
   */
  ngOnInit(): void {
    this.dataSource.count$.pipe(takeUntil(this.onDestroy$)).subscribe((count) => (this.totalCount = count));
  }

  /**
   * Cleans up subscriptions and subjects when the component is destroyed.
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  /**
   * Loads data using current filters
   */
  public onPage(event: PageEvent): void {
    this.filters = {
      ...this.filters,
      page: event.pageIndex + 1,
      pageSize: event.pageSize,
    };

    this.loadDataSource();
  }

  /**
   * Loads predisposition using current filters
   */
  private loadDataSource(): void {
    this.dataSource.loadData({
      page: this.filters.page ?? 1,
      pageSize: this.filters.pageSize ?? 10,
      ...(this.filters.tags?.length ? { tags: this.filters.tags } : {}),
    });
  }

  /**
   * Reloads the risks list with new tag filters
   * @param tags List of selected risk tags
   */
  public onTagsChanged(tags: string[]): void {
    this.filters = {
      ...this.filters,
      page: 1,
      tags: tags,
    };

    this.loadDataSource();
  }
}
